












































































































































interface tableData {
    accountBookId: number
    depreciateSubject: string
    depreciateSubjectText: string
    feeSubject: string
    feeSubjectText: string
    id: number
    isInit: number
    leaf: number
    method: string
    name: string
    no: string
    oldValueRate: number
    useMonth: number
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class AssetClass extends Vue {
    @Prop({ type: Object })
    assetData?: tableData;

    @Prop({ type: Boolean })
    isAdd?: boolean;

    @Prop({ type: Number })
    assetType!: number;

    pno: string | null = null;
    
    get options() {
        switch(this.assetType) {
            case 1:
                return ["年限平均", "双倍余额递减", "不折旧"];
            case 2:
                return ["平均年限法", "不摊销"];
            case 3:
                return ["平均年限法"];
            default:
                return ["年限平均", "双倍余额递减", "不折旧"];
        }
    }
    method = this.options[0];
    no: string = "";
    name: string = "";
    useMonth: string = "";
    oldValueRate: number = 0;
    feeSubjectText: string = "";
    feeSubject: Subject.Subject | null = null;
    depreciateSubjectText: string = "";
    depreciateSubject: Subject.Subject | null = null;
    subjectList: Subject.Subject[] = [];

    noTipShow: boolean = false;
    nameTipShow: boolean = false;
    disabled: boolean = false;
    classNameDisabled: boolean = false;

    mounted() {
        this.init(this.assetData)
        this.getSubjects()
    }

    returnNum(e: any, name: string) {
        if (name === "no")
            this.noTipShow = true;
        if (name === "name") {
            this.nameTipShow = true;
            return
        }
        let keycodes = [8, 9, 12, 13, 32, 37, 38, 39, 40, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 187, 190]
        if (keycodes.indexOf(e.keyCode) == -1) {
            e.preventDefault();
            return
        }
    }
    // 类别编码
    get noTip() {
        if (this.no === "" && this.noTipShow == true) {
            return true
        } else {
            return false
        }
    }
    // 类别名称
    get nameTip() {
        if (this.name === "" && this.nameTipShow == true) {
            return true
        } else {
            return false
        }
    }
    // 残值率
    get oldValueRateTip() {
        if (Number(this.oldValueRate) < 100) {
            return false
        } else {
            return true
        }
    }
    // 使用期限
    get useMonthTip() {
        if (Number(this.useMonth) < 1000) {
            return false
        } else {
            return true
        }
    }

    //获取科目列表
    getSubjects() {
        Vue.axios
            .post(`subjects/findleaf`, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                this.subjectList = res.data
            });
    }

    // 折旧选择
    methodChange(val: string) {
        this.method = val;
    }
    // 费用科目选择
    feeSubjectChange(val: Subject.Subject) {
        this.feeSubject = val;
    }
    // 折旧科目选择
    depreciateSubjectChange(val: Subject.Subject) {
        this.depreciateSubject = val;
    }
    // 初始化数据
    init(val: any) {
        this.noTipShow = false;
        this.nameTipShow = false;
        if (this.isAdd) {
            this.disabled = false;
            this.classNameDisabled = false;
            this.pno = null;
            this.no = "";
            this.name = "";
            this.useMonth = "";
            this.oldValueRate = 0;
            this.method = this.options[0];
            this.feeSubjectText = "";
            this.depreciateSubjectText = "";
        }
        else {
            if (val.leaf === 0)
                this.disabled = true
            if (val.isInit === 1)
                this.classNameDisabled = true
            this.pno = val.pno;
            this.no = val.no.substring(val.no.length - 2);
            this.name = val.name;
            this.useMonth = val.useMonth;
            this.oldValueRate = val.oldValueRate;
            this.method = val.method;
            this.feeSubjectText = val.feeSubjectText;
            this.depreciateSubjectText = val.depreciateSubjectText;
            this.depreciateSubject = val.depreciateSubject;
            this.feeSubject = val.feeSubject;
        }

    }

    save() {
        let param: any = {};
        if (this.isAdd) {
            param = {
                id: null,
                accountBookId: this.$store.state.accountBook.id,
                pno: this.pno,
                no: this.no,
                name: this.name,
                useMonth: this.useMonth,
                oldValueRate: this.oldValueRate,
                depreciateSubject: this.depreciateSubject,
                feeSubject: this.feeSubject,
                method: this.method,
                isInit: null,
                leaf: null
            }
        }
        else {
            if (this.assetData) {
                if (JSON.stringify(this.assetData) !== "{}") {
                    param = {
                        id: this.assetData.id,
                        accountBookId: this.assetData.accountBookId,
                        pno: this.pno,
                        no: this.no,
                        name: this.name,
                        useMonth: this.useMonth,
                        oldValueRate: this.oldValueRate,
                        depreciateSubject: this.depreciateSubject,
                        feeSubject: this.feeSubject,
                        method: this.method,
                        isInit: this.assetData.isInit,
                        leaf: this.assetData.leaf
                    }
                }
            }
        }

        param.assetType = this.assetType;
        Vue.axios
            .post(`fixedAssetsCategory/save`, param)
            .then(res => {
                this.$emit("success")
            });
    }
    close() {
        this.$emit("close")
    }

    pnoBlur() {
        if (this.pno === null) return;
        if ((this.pno).toString().length == 1) {
            this.pno = `0${this.pno}`
        }
    }
    noBlur() {
        if ((this.no).toString().length == 1) {
            this.no = `0${this.no}`
        }
    }

}
